
import Vue from 'vue';
import Banner from '../components-pc/Banner.vue';
import CategorySection from '../components-pc/CategorySection.vue';
import HomeFooter from '../components-pc/HomeFooter.vue';
import More from '../components-pc/More.vue';
import NewsLayout from '../components-pc/NewsLayout.vue';
import PcPageLoading from '../components-pc/PcPageLoading.vue';
import { getBaseInfo, getNewsColumn } from '../api';

const HOME_NEWS_PAGE_SIZE = 10;

interface InfoItem {
  title: string;
  lines: string[];
}

interface TimelineItem {
  title: string;
  text: string;
}

export default Vue.extend({
  name: 'HomePc',
  components: {
    Banner,
    CategorySection,
    HomeFooter,
    More,
    NewsLayout,
    PcPageLoading,
  },
  data() {
    return {
      activeNewsIndex: 0,
      pageLoading: false,
      infoList: [
        {
          title: '组织机构',
          lines: [
            '主办单位：中共重庆市委宣传部、重庆市教育委员会',
            '承办单位：重庆大学新闻学院、重庆大学融媒体中心',
            '协办单位：西南大学、西南政法大学、重庆师范大学、重庆工商大学、四川外国语大学',
          ],
        },
        {
          title: '参赛对象及要求',
          lines: [
            '（一）参赛对象',
            '重庆市高等院校新闻传播、出版印刷、设计、影视编导、美术等相关专业的在校研究生、本科生和专科生（含高职、高专）。',
            '（二）参赛形式',
            '个人或团队，超过3人，以团队名义申报（团队人数一般不超过6人，需明确主要创作者及分工），每件作品可邀请1-2名新闻机构从业人员或高校教师作为指导老师。',
            '（三）评选方式',
            '采取评委初审、网络投票和专家复审相结合的方式，总分为100分。通过评委初审的作品进入网络展播与投票环节。网络投票占20%，专家评审占80%。参赛作品应为2026年1月1日至2026年10月10日期间创作的作品。系列作品视为1件。',
          ],
        },
        {
          title: '奖项设置',
          lines: [
            '大赛全国总决赛设一等奖、二等奖、三等奖，另设地方和高校优秀组织奖、优秀指导教师奖等奖项。',
          ],
        },
      ] as InfoItem[],
      timelineList: [
        {
          title: '启动与宣传阶段',
          text: '6月25日—7月20日',
        },
        { title: '作品征集阶段', text: '7月21日—10月10日' },
        { title: '初评阶段', text: '10月11日—10月25日' },
        { title: '网络投票阶段', text: '10月26日—11月6日' },
        { title: '终评阶段', text: '11月7日—11月15日' },
        { title: '公示阶段', text: '11月16日—11月20日' },
        { title: '巡展与颁奖阶段', text: '11月—12月' },
      ] as TimelineItem[],
      newsList: [] as any[],
      newsColumnId: null as any,
    };
  },
  created() {
    this.initPageData();
  },
  methods: {
    async initPageData() {
      this.pageLoading = true;
      try {
        await this.fetchBaseInfo();
        await this.fetchNewsList();
      } finally {
        this.pageLoading = false;
      }
    },
    async fetchBaseInfo() {
      try {
        const res: any = await getBaseInfo();
        this.newsColumnId = res.data && res.data.classId;
      } catch (err) {
        console.error('基础信息获取失败：', err);
      }
    },
    async fetchNewsList() {
      if (
        this.newsColumnId === null ||
        this.newsColumnId === undefined ||
        this.newsColumnId === ''
      ) {
        return;
      }

      try {
        const res: any = await getNewsColumn({
          page: 1,
          pageSize: HOME_NEWS_PAGE_SIZE,
          columnId: this.newsColumnId,
        });
        const newsList = this.getNewsPayload(res).slice(0, 3);

        if (newsList.length) {
          this.newsList = newsList;
          this.activeNewsIndex = 0;
        }
      } catch (err) {
        console.error('相关新闻获取失败：', err);
      }
    },

    getNewsPayload(res: any): any[] {
      const payload = res && res.data !== undefined ? res.data : res;

      if (Array.isArray(payload)) {
        return payload;
      }
      if (!payload || typeof payload !== 'object') {
        return [];
      }
      if (Array.isArray(payload.list)) {
        return payload.list;
      }
      if (Array.isArray(payload.rows)) {
        return payload.rows;
      }
      if (Array.isArray(payload.data)) {
        return payload.data;
      }
      if (payload.data && typeof payload.data === 'object') {
        return this.getNewsPayload(payload.data);
      }

      return [];
    },
    goRule() {
      this.$router.push('/cqcc/rule').catch((err: Error) => err);
    },
    goNews() {
      this.$router.push('/cqcc/news').catch((err: Error) => err);
    },
  },
});
